<template>
 <!-- <router-view />-->
 <!-- vue3.0配置 -->
  <router-view v-slot="{ Component }">
    <keep-alive>
      <component :is="Component"  v-if="$route.meta.keepAlive"/>
    </keep-alive>
    <component :is="Component"  v-if="!$route.meta.keepAlive"/>
  </router-view> 
</template>

<style >
/* 
lang="less"
  iOS 微信字体适配核心代码 
  强制禁止 iOS WebView 根据系统字体设置调整文本大小
*/
body, html {
  -webkit-text-size-adjust: 100% !important;
  text-size-adjust: 100% !important;
  -moz-text-size-adjust: 100% !important;
}

/* 
  可选：确保根节点字体基准稳定 
  如果你的项目使用了 rem 布局，建议在此处固定 html 的 font-size 
  或者确保你的 rem 计算逻辑不受微信干扰
*/
html {
  /* 根据你的设计稿基准设置，例如 16px 或动态计算的值 */
  font-size: 16px; 
}
</style>

